import React from 'react';

export const TradersReviews = () => (
  <>
    {/* ========== Frame 14 (общий контейнер) ========== */}
    <div
      style={{
        position: 'absolute',
        width: 1287.9,
        height: 252.9,
        left: 'calc(50% - 1287.9px / 2 - 0.05px)',
        top: 2719,
      }}
    >
      {/* ---------- Frame 11 (Roberto Lima) ---------- */}
      <div style={{ position: 'absolute', width: 407.7, height: 252.9, left: 0, top: 0 }}>
        {/* Rectangle 11 */}
        <div
          style={{
            position: 'absolute',
            width: 407.7,
            height: 252.9,
            left: 0,
            top: 0,
            background: 'rgba(127, 56, 243, 0.15)',
            backgroundBlendMode: 'plus-lighter',
            mixBlendMode: 'normal',
            boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                        -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                        inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),
                        inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,
            backdropFilter: 'blur(4.392px)',
            borderRadius: 45,
          }}
        >
          {/* Rectangle 12 */}
          <div
            style={{
              position: 'absolute',
              width: 377.1,
              height: 140.4,
              left: 15.3,
              top: 104.4,
              background: 'rgba(127, 56, 243, 0.15)',
              backgroundBlendMode: 'plus-lighter',
              mixBlendMode: 'normal',
              boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                          -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                          inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),
                          inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,
              backdropFilter: 'blur(4.392px)',
              borderRadius: 45,
            }}
          />

          {/* Имя */}
          <div
            style={{
              position: 'absolute',
              width: 185,
              height: 34,
              left: 101.7,
              top: 29.7,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 28.8,
              lineHeight: '34px',
              textAlign: 'start',
              color: '#FFFFFF',
            }}
          >
            Roberto Lima
          </div>

          {/* Роль/возраст */}
          <div
            style={{
              position: 'absolute',
              width: 151,
              height: 17,
              left: 'calc(50% - 151px / 2 - 26.65px)',
              top: 61.2,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 14.4,
              lineHeight: '17px',
              color: 'rgba(255, 255, 255, 0.8)',
            }}
          >
            Day Trader • 42 years
          </div>

          {/* Отзыв */}
          <div
            style={{
              position: 'absolute',
              width: 333,
              height: 114.3,
              left: 'calc(50% - 333px / 2 + 3.15px)',
              top: 126.9,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 19.44,
              lineHeight: '23px',
              color: 'rgba(255, 255, 255, 0.8)',
            }}
          >
            “After 10 years on the market, finally find a tool that really it works. My results have improved 300%!”
          </div>

          {/* Verified-лабель */}
          <div
            style={{
              position: 'absolute',
              width: 87.3,
              height: 19.8,
              left: 305.1,
              top: 58.5,
              background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
              borderRadius: 9.9,
            }}
          />
          <div
            style={{
              position: 'absolute',
              width: 65,
              height: 17,
              left: 'calc(50% - 65px / 2 + 145.45px)',
              top: 59.4,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 14.4,
              lineHeight: '17px',
              textTransform: 'uppercase',
              color: '#FFFFFF',
            }}
          >
            Verified
          </div>

          {/* Аватар: внешний эллипс */}
          <div
            style={{
              position: 'absolute',
              width: 63.9,
              height: 63.9,
              left: 28.8,
              top: 24.3,
              background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
              mixBlendMode: 'normal',
              boxShadow: `-9.03182px -8.41752px 38.88px -9.72px rgba(0,0,0,0.15),
                          -1.5053px -1.40292px 9.72px -6.48px rgba(0,0,0,0.15),
                          inset 1.73863px 1.62037px 7.4844px rgba(255,255,255,0.126),
                          inset 0.985974px 0.918913px 3.7422px rgba(255,255,255,0.126)`,
              backdropFilter: 'blur(6.1398px)',
              borderRadius: '50%',
            }}
          />
          {/* Внутренний эллипс-заглушка (вместо url(image)) */}
          <div
            style={{
              position: 'absolute',
              width: 56.7,
              height: 56.7,
              left: 32.4,
              top: 27.9,
              background: 'rgba(255,255,255,0.2)',
              mixBlendMode: 'normal',
              boxShadow: `-9.03182px -8.41752px 38.88px -9.72px rgba(0,0,0,0.15),
                          -1.5053px -1.40292px 9.72px -6.48px rgba(0,0,0,0.15),
                          inset 1.73863px 1.62037px 7.4844px rgba(255,255,255,0.126),
                          inset 0.985974px 0.918913px 3.7422px rgba(255,255,255,0.126)`,
              backdropFilter: 'blur(6.1398px)',
              borderRadius: '50%',
            }}
          />
        </div>
      </div>

      {/* ---------- Frame 12 (Isabella Alves) ---------- */}
      <div style={{ position: 'absolute', width: 407.7, height: 252.9, left: 440.1, top: 0 }}>
        {/* Rectangle 11 */}
        <div
          style={{
            position: 'absolute',
            width: 407.7,
            height: 252.9,
            left: 0,
            top: 0,
            background: 'rgba(127, 56, 243, 0.15)',
            backgroundBlendMode: 'plus-lighter',
            mixBlendMode: 'normal',
            boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                        -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                        inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),
                        inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,
            backdropFilter: 'blur(4.392px)',
            borderRadius: 45,
          }}
        >
          {/* Rectangle 12 */}
          <div
            style={{
              position: 'absolute',
              width: 377.1,
              height: 136.8,
              left: 15.3,
              top: 104.4,
              background: 'rgba(127, 56, 243, 0.15)',
              backgroundBlendMode: 'plus-lighter',
              mixBlendMode: 'normal',
              boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                          -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                          inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),
                          inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,
              backdropFilter: 'blur(4.392px)',
              borderRadius: 45,
            }}
          />

          {/* Имя */}
          <div
            style={{
              position: 'absolute',
              width: 190,
              height: 34,
              left: 101.7,
              top: 29.7,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 28.8,
              lineHeight: '34px',
              textAlign: 'start',
              color: '#FFFFFF',
            }}
          >
            Isabella Alves
          </div>

          {/* Роль/возраст */}
          <div
            style={{
              position: 'absolute',
              width: 167,
              height: 17,
              left: 'calc(50% - 167px / 2 - 18.65px)',
              top: 61.2,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 14.4,
              lineHeight: '17px',
              color: 'rgba(255, 255, 255, 0.8)',
            }}
          >
            Swing Trader • 30 years
          </div>

          {/* Отзыв */}
          <div
            style={{
              position: 'absolute',
              width: 341.1,
              height: 114.3,
              left: 'calc(50% - 341.1px / 2 + 7.2px)',
              top: 126.9,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 19.44,
              lineHeight: '23px',
              color: 'rgba(255, 255, 255, 0.8)',
            }}
          >
            “As the mother of two children, I need fast and efficient analysis. NEXTGREEN allows me to operate in the intervals of my day!”
          </div>

          {/* Verified-лабель */}
          <div
            style={{
              position: 'absolute',
              width: 87.3,
              height: 19.8,
              left: 305.1,
              top: 58.5,
              background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
              borderRadius: 9.9,
            }}
          />
          <div
            style={{
              position: 'absolute',
              width: 65,
              height: 17,
              left: 'calc(50% - 65px / 2 + 145.45px)',
              top: 59.4,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 14.4,
              lineHeight: '17px',
              textTransform: 'uppercase',
              color: '#FFFFFF',
            }}
          >
            Verified
          </div>

          {/* Аватар: внешний эллипс */}
          <div
            style={{
              position: 'absolute',
              width: 63.9,
              height: 63.9,
              left: 28.8,
              top: 24.3,
              background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
              mixBlendMode: 'normal',
              boxShadow: `-9.03182px -8.41752px 38.88px -9.72px rgba(0,0,0,0.15),
                          -1.5053px -1.40292px 9.72px -6.48px rgba(0,0,0,0.15),
                          inset 1.73863px 1.62037px 7.4844px rgba(255,255,255,0.126),
                          inset 0.985974px 0.918913px 3.7422px rgba(255,255,255,0.126)`,
              backdropFilter: 'blur(6.1398px)',
              borderRadius: '50%',
            }}
          />
          {/* Внутренний эллипс-заглушка */}
          <div
            style={{
              position: 'absolute',
              width: 56.7,
              height: 56.7,
              left: 32.4,
              top: 27.9,
              background: 'rgba(255,255,255,0.2)',
              mixBlendMode: 'normal',
              boxShadow: `-9.03182px -8.41752px 38.88px -9.72px rgba(0,0,0,0.15),
                          -1.5053px -1.40292px 9.72px -6.48px rgba(0,0,0,0.15),
                          inset 1.73863px 1.62037px 7.4844px rgba(255,255,255,0.126),
                          inset 0.985974px 0.918913px 3.7422px rgba(255,255,255,0.126)`,
              backdropFilter: 'blur(6.1398px)',
              borderRadius: '50%',
            }}
          />
        </div>
      </div>

      {/* ---------- Frame 13 (Carlos Eduardo) ---------- */}
      <div style={{ position: 'absolute', width: 407.7, height: 252.9, left: 880.2, top: 0 }}>
        {/* Rectangle 11 */}
        <div
          style={{
            position: 'absolute',
            width: 407.7,
            height: 252.9,
            left: 0,
            top: 0,
            background: 'rgba(127, 56, 243, 0.15)',
            backgroundBlendMode: 'plus-lighter',
            mixBlendMode: 'normal',
            boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                        -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                        inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),
                        inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,
            backdropFilter: 'blur(4.392px)',
            borderRadius: 45,
          }}
        >
          {/* Rectangle 12 */}
          <div
            style={{
              position: 'absolute',
              width: 377.1,
              height: 136.8,
              left: 15.3,
              top: 104.4,
              background: 'rgba(127, 56, 243, 0.15)',
              backgroundBlendMode: 'plus-lighter',
              mixBlendMode: 'normal',
              boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                          -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                          inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),
                          inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,
              backdropFilter: 'blur(4.392px)',
              borderRadius: 45,
            }}
          />

          {/* Имя */}
          <div
            style={{
              position: 'absolute',
              width: 250,
              height: 34,
              left: 101.8,
              top: 29,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 28.8,
              lineHeight: '34px',
              textAlign: 'start',
              color: '#FFFFFF',
            }}
          >
            Carlos Eduardo
          </div>

          {/* Роль/возраст */}
          <div
            style={{
              position: 'absolute',
              width: 153,
              height: 17,
              left: 'calc(50% - 153px / 2 - 25.65px)',
              top: 61.2,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 14.4,
              alignContent: 'center',
              justifyContent: 'center',
              lineHeight: '17px',
              color: 'rgba(255, 255, 255, 0.8)',
            }}
          >
            Scalper • 26 years old
          </div>

          {/* Отзыв */}
          <div
            style={{
              position: 'absolute',
              width: 341.1,
              height: 114.3,
              left: 'calc(50% - 341.1px / 2 + 7.2px)',
              top: 126.9,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 19.44,
              lineHeight: '23px',
              color: 'rgba(255, 255, 255, 0.8)',
            }}
          >
            “Economics student who does trading to pay for college. With the NEXTGREEN, I can be consistent in operations!”
          </div>

          {/* Verified-лабель */}
          <div
            style={{
              position: 'absolute',
              width: 87.3,
              height: 19.8,
              left: 305.1,
              top: 58.5,
              background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
              borderRadius: 9.9,
            }}
          />
          <div
            style={{
              position: 'absolute',
              width: 65,
              height: 17,
              left: 'calc(50% - 65px / 2 + 145.45px)',
              top: 59.4,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 14.4,
              lineHeight: '17px',
              textTransform: 'uppercase',
              color: '#FFFFFF',
            }}
          >
            Verified
          </div>

          {/* Аватар: внешний эллипс */}
          <div
            style={{
              position: 'absolute',
              width: 63.9,
              height: 63.9,
              left: 28.8,
              top: 24.3,
              background: 'url(./1.png) center/cover no-repeat',
              mixBlendMode: 'normal',
              boxShadow: `-9.03182px -8.41752px 38.88px -9.72px rgba(0,0,0,0.15),
                          -1.5053px -1.40292px 9.72px -6.48px rgba(0,0,0,0.15),
                          inset 1.73863px 1.62037px 7.4844px rgba(255,255,255,0.126),
                          inset 0.985974px 0.918913px 3.7422px rgba(255,255,255,0.126)`,
              backdropFilter: 'blur(6.1398px)',
              borderRadius: '50%',
            }}
          />
          {/* Внутренний эллипс-заглушка */}
          <div
            style={{
              position: 'absolute',
              width: 56.7,
              height: 56.7,
              left: 32.4,
              top: 27.9,
              background: 'rgba(255,255,255,0.2)',
              mixBlendMode: 'normal',
              boxShadow: `-9.03182px -8.41752px 38.88px -9.72px rgba(0,0,0,0.15),
                          -1.5053px -1.40292px 9.72px -6.48px rgba(0,0,0,0.15),
                          inset 1.73863px 1.62037px 7.4844px rgba(255,255,255,0.126),
                          inset 0.985974px 0.918913px 3.7422px rgba(255,255,255,0.126)`,
              backdropFilter: 'blur(6.1398px)',
              borderRadius: '50%',
            }}
          />
        </div>
      </div>
    </div>
  </>
);